import { find, isEmpty } from 'lodash';

const firstEmpty = fromArray => find(fromArray, isEmpty);

export default firstEmpty;
